export function getOrderPrice(order) {
  return order.price != null
    ? Number(order.price)
    : Number(order.product_data.price);
}

// Área de producción (Cocina, Bar…) de la categoría del pedido; "" si no tiene
// y entonces no pasa por ninguna pantalla (el mozo lo entrega directo).
export function getProductionArea(order) {
  return (order.product_data?.category_data?.production_area || "").trim();
}

// WhatsApp, Venta rápida y Delivery: todo el pedido sale en un solo lote (una
// bolsa). El salón entrega plato por plato.
export function isBatchKind(kind) {
  return !!kind && kind !== "SALON";
}

// Cuántos pedidos de la lista siguen sin que su área los marque "Listo".
export function countWaitingForArea(orders) {
  return (orders || []).filter(
    (order) => order.status === "PENDING" && getProductionArea(order)
  ).length;
}

// Números de mesa (ids) de WhatsApp / Venta rápida / Delivery cuyo lote aún no
// está completo: algún pedido sigue sin que su área lo marque "Listo". Sus
// platos ya listos no se avisan al mozo todavía (todo sale junto).
export function getIncompleteBatchTables(openOrders) {
  const incomplete = new Set();
  (openOrders || []).forEach((order) => {
    if (
      order.table &&
      isBatchKind(order.table_data?.kind) &&
      order.status === "PENDING" &&
      getProductionArea(order)
    ) {
      incomplete.add(order.table);
    }
  });
  return incomplete;
}
